'use es6';

import I18n from 'I18n';
import { isEqual, isEmpty } from 'underscore';
import PostSubmissionOptions from 'forms-utils-lib/constants/formDefinition/PostSubmissionOptions';
import { getPrefilledFields } from 'FormsUI/selectors/FormPreview';
import { getDefinition, getPostSubmissionOption } from 'FormsUI/selectors/FormDefinition';
function createAction(name) {
  return `@@preview/${name}`;
}
export const UPDATE_FORM_PREVIEW = createAction('UPDATE_FORM_PREVIEW');
const SUBMIT_FORM_PREVIEW = createAction('SUBMIT_FORM_PREVIEW');
export const REQUEST_PREVIEW_RENDER = createAction('REQUEST_PREVIEW_RENDER');
export const SUCCEEDED_PREVIEW_RENDER = createAction('SUCCEEDED_PREVIEW_RENDER');
export const FAILED_PREVIEW_RENDER = createAction('FAILED_PREVIEW_RENDER');
export const SET_CONTACT_PREVIEW = createAction('SET_PREVIEW_CONTACT');
export const SHOW_VARIANT = createAction('SHOW_VARIANT');
export const SET_STEP = createAction('SET_STEP');
function setFormPreview(formPreview) {
  return {
    type: UPDATE_FORM_PREVIEW,
    formPreview
  };
}
export function updateFormPreview(formFieldName, isChecked) {
  return (dispatch, getState) => {
    const prefilledFieldsMap = getPrefilledFields(getState());
    dispatch(setFormPreview(prefilledFieldsMap.set(formFieldName, isChecked)));
  };
}
export function requestRender() {
  return {
    type: REQUEST_PREVIEW_RENDER
  };
}
export function succeededRender() {
  return {
    type: SUCCEEDED_PREVIEW_RENDER
  };
}
export function failedRender() {
  return {
    type: FAILED_PREVIEW_RENDER
  };
}
export function setPreviewContact(contact) {
  return {
    type: SET_CONTACT_PREVIEW,
    contact
  };
}
export function setPagePreviewStep(step) {
  return {
    type: SET_STEP,
    payload: step
  };
}
export function submitFormPreview({
  isSuccessful = false,
  isAlreadySubmitted = false,
  isPreviewPanelAvailable = false
}) {
  return (dispatch, getState) => {
    const postSubmissionOption = getPostSubmissionOption(getState());
    const formDefinition = getDefinition(getState());
    let message = '';
    if (isAlreadySubmitted) {
      if (isEqual(PostSubmissionOptions.REDIRECT_PAGE, postSubmissionOption) && !isEmpty(formDefinition.redirect)) {
        message = I18n.text('editor.preview.submitAlertAlreadySubmittedRedirectPage', {
          redirectUrl: formDefinition.redirect
        });
      } else {
        message = I18n.text('editor.preview.submitAlertAlreadySubmitted');
      }
    } else if (isSuccessful) {
      let postSubmissionOptionMessage = '';
      if (isEqual(PostSubmissionOptions.REDIRECT_PAGE, postSubmissionOption) && !isEmpty(formDefinition.redirect)) {
        postSubmissionOptionMessage = I18n.text('editor.preview.submitAlertRedirectPage', {
          redirectUrl: formDefinition.redirect
        });
      } else if (isEqual(PostSubmissionOptions.THANK_YOU_MESSAGE, postSubmissionOption) && !isEmpty(formDefinition.inlineMessage)) {
        postSubmissionOptionMessage = I18n.text('editor.preview.submitAlertThankYouMessage');
      } else {
        postSubmissionOptionMessage = I18n.text('editor.preview.submitAlertEmptyAction');
      }
      message = `${I18n.text('editor.preview.submitAlertSuccessful')}\n${postSubmissionOptionMessage}`;
    } else if (isPreviewPanelAvailable) {
      message = I18n.text('editor.preview.submitAlertWithPreivewPanel');
    } else {
      message = I18n.text('editor.preview.submitAlert');
    }
    dispatch({
      type: SUBMIT_FORM_PREVIEW,
      meta: {
        notification: {
          type: 'info',
          message
        }
      }
    });
  };
}